'use strict';
// @flow

import * as Immutable from 'immutable';
import Cookies from 'universal-cookie';
import { createSelector } from 'reselect';
import { push } from 'react-router-redux';

import type { Action, Dispatch, GetState, State } from 'lib/types';

import * as Paths from '../../paths';
import { ordenacaoSelector, tipoSelector, opcaoResumoSelector } from './filtro_livre';
import { currentRouteSelector } from '../routing';
import type { IFiltro } from './filtro_livre';

export const LISTA_CARREGANDO        = 'nfe/lista/LISTA_CARREGANDO',
             LISTA_CARREGADA         = 'nfe/lista/LISTA_CARREGADA',
             ALTERA_LAST_PATH        = 'nfe/lista/ALTERA_LAST_PATH',
             ALTERA_QUERY_EXPORTACAO = 'nfe/lista/ALTERA_QUERY_EXPORTACAO',
             SET_URL                 = 'nfe/lista/SET_URL';

const cookie = new Cookies();

const INITIAL_STATE = Immutable.fromJS({
  url: '',
  carregando: false,
  queryExportacao: {},
  lastPath: cookie.get('lastPathNfe') || '/app/nfe/lista/todos',
});

export default function reducer(state : any = INITIAL_STATE, action : Action = {}) {
  switch (action.type) {
    case LISTA_CARREGANDO:
      return state.set('carregando', true);
    case LISTA_CARREGADA:
      return state.set('carregando', false);
    case ALTERA_LAST_PATH:
      return state.set('lastPath', action.path);
    case ALTERA_QUERY_EXPORTACAO:
      return state.set('queryExportacao', action.queryExportacao);
    case SET_URL:
      return state.set('url', action.url);
    default:
      return state;
  }
}

// selectors

export const rootSelector = (state : State) => state.getIn(['nfe', 'lista'], Immutable.Map());
export const urlSelector = createSelector<*, *, *, *>(rootSelector, (root) => root.get('url'));
export const carregandoSelector = createSelector<*, *, *, *>(rootSelector, (root) => root.get('carregando'));
export const lastPathSelector = createSelector<*, *, *, *>(rootSelector, (root) => root.get('lastPath', '/app/nfe/lista/todos'));
export const queryExportacaoSelectorNfe = createSelector<*, *, *, *>(rootSelector, (root) => root.get('queryExportacao'));

// actions

export function listaCarregando() {
  return { type: LISTA_CARREGANDO };
}

export function listaCarregada() {
  return { type: LISTA_CARREGADA };
}

export function setUrl(url : string) {
  return { type: SET_URL, url };
}

// thunk actions
export function trocaPagina(page : number) {
  return async function(dispatch : Dispatch<*>, getState : GetState) {
    const route            = currentRouteSelector(getState()),
          ordenacaoAtual   = ordenacaoSelector(getState()),
          opcaoResumoAtual = opcaoResumoSelector(getState()),
          query            = route.get('query').toJS();

    const filtro = {
      d: '', page: String(page), s: ordenacaoAtual.get('s'), sd: ordenacaoAtual.get('sd'), f: opcaoResumoAtual,
    };

    dispatch(carregaLista(query, filtro));
  };
}

export function carregaLista(query : any = {}, filtro : IFiltro) {
  return async function(dispatch : Dispatch<any>, getState : GetState) {
    const tipo = tipoSelector(getState()),
          url  = Paths.nfesFilter.lista[tipo](query, filtro);

    dispatch(push(url));

    const queryExportacao = query && query.q ? { d: tipo, q: query.q, f: filtro.f } : { d: tipo, f: filtro.f };

    await dispatch({ type: ALTERA_QUERY_EXPORTACAO, queryExportacao });

    await dispatch({ type: ALTERA_LAST_PATH, path: url });
    cookie.set('lastPathNfe', url);

    await dispatch(listaCarregando());
    await dispatch(setUrl(url));
    await dispatch(listaCarregada());
  };
}
